import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function MidPageCTA() {
  return <section className="bg-[#2D2A3E] py-10 px-4" data-id="element-205">
      <div className="max-w-3xl mx-auto text-center" data-id="element-206">
        <p className="text-white/60 text-sm mb-2" data-id="element-207">
          ¿Ya entendiste cómo funciona?
        </p>
        <p className="text-white font-bold text-xl md:text-2xl mb-1" data-id="element-208">
          Empieza hoy mismo por $11.99
        </p>
        <p className="text-white/40 text-sm line-through mb-6" data-id="element-209">
          Valor Total: $75
        </p>

        <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gradient-to-r from-[#C4973B] to-[#D4A84C] text-white font-bold text-lg py-4 px-10 rounded-full shadow-xl shadow-[#C4973B]/30 hover:scale-105 hover:shadow-2xl transition-all group" data-id="element-210">
          👉 DESCARGAR MI EBOOK AHORA
          <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-211" />
        </a>

        <div className="mt-5 flex items-center justify-center gap-4 text-white/40 text-xs" data-id="element-212">
          <span className="flex items-center gap-1" data-id="element-213">
            <ShieldCheck className="h-3.5 w-3.5" data-id="element-214" /> Garantía 7 días
          </span>
          <span data-id="element-215">·</span>
          <span data-id="element-216">Acceso inmediato</span>
          <span data-id="element-217">·</span>
          <span data-id="element-218">Pago único</span>
        </div>
      </div>
    </section>;
}